// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTopBtn_scrollToTop__mJibD","fadeIn":"ScrollToTopBtn_fadeIn__xZ2sZ"};